export default {
  //get
  QueryCountry: '/api/myprofile/Area/QueryCountry',//查询国家
  QueryProvince: '/api/myprofile/Area/QueryProvince',//查询省份
  QueryCity: '/api/myprofile/Area/QueryCity',//查询城市
  QueryCounty: '/api/myprofile/Area/QueryCounty',//查询区县
  QueryMyAddresses:'/api/myprofile/Address/QueryMyAddresses',//获取地址列表
  //post
  login: '/identity/login', //登录
  SaveAddress:'/api/myprofile/Address/Save',//保存/修改地址
  SetDefaultAddress:'/api/myprofile/Address/SetDefaultAddress',//设置默认地址
  DeleteAddress:'/api/myprofile/Address/Delete',//删除地址
}



// WEBPACK FOOTER //
// ./src/api/api.js